import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { ShCacheInterceptor } from '@stylehaven/components';
import { RefreshTokenInterceptor } from './refresh-token.interceptor';
import { TokenInterceptor } from './token.interceptor';

// The order of these interceptors is very important, do not change or application will not handle refresh token as it should.

export const tokenInterceptorProviders = [
    {
        provide: HTTP_INTERCEPTORS,
        useClass: RefreshTokenInterceptor,
        multi: true
    },
    {
        provide: HTTP_INTERCEPTORS,
        useClass: TokenInterceptor,
        multi: true
    },
    {
        provide: HTTP_INTERCEPTORS,
        useClass: ShCacheInterceptor,
        multi: true
    }
];
